module.exports = {
          srcSet: __webpack_public_path__ + "public/images/8d03ad789c46f4908b85769ee76e4472-1200.webp"+" 1200w",
          images:[ {path: __webpack_public_path__ + "public/images/8d03ad789c46f4908b85769ee76e4472-1200.webp",width: 1200,height: 800}],
          src: __webpack_public_path__ + "public/images/8d03ad789c46f4908b85769ee76e4472-1200.webp",
          toString:function(){return __webpack_public_path__ + "public/images/8d03ad789c46f4908b85769ee76e4472-1200.webp"},
          
          width: 1200,
          height: 800
        }